if(!customElements.get('custom-logo-list')){
 
    class CustomLogoList extends HTMLElement {
        constructor(){
            super();
    
            this.swiperContainer = this.querySelector('.swiper-container');
            this.initSwiper();
        }
    
        initSwiper(){
            var totalSlides = parseInt(this.swiperContainer.dataset.totalSlides);
            var numPerView = parseInt(this.swiperContainer.dataset.numPerView);
            var slidesPerView = (numPerView && totalSlides > numPerView)? numPerView : totalSlides;
    
            var loop = (this.swiperContainer.dataset.loop == 'true')? true : false;
    
            var swiperSettings = {
                init: false,
                initialSlide: 0,
                loop: loop,
                spaceBetween: 30,
                centeredSlides: false,
                speed: 500,
                watchOverflow: true,
                breakpoints: {
                    0: { slidesPerView: slidesPerView < 2? slidesPerView : 2 },
                    576: {
                        slidesPerView: slidesPerView < 3? slidesPerView : 3
                    },
                    991: {
                        slidesPerView: slidesPerView < 5? slidesPerView : 5
                    },
                    1200: {
                        slidesPerView: slidesPerView < 8? slidesPerView : 8
                    }
                },
                observer: true,
                observeSlideChildren: true
            }
    
            if(this.swiperContainer.querySelector('.swiper-pagination')){
                swiperSettings.pagination = {
                    el: this.querySelector('.swiper-pagination')
                }
            }
    
            if(this.swiperContainer.querySelector('.swiper-button-next')){
                swiperSettings.navigation = {
                    nextEl: this.querySelector('.swiper-button-next'),
                    prevEl: this.querySelector('.swiper-button-prev')
                }
            }
     
            const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            const autoplayEnabled = this.swiperContainer.dataset.autoplay == 'true' && !prefersReducedMotion;

            if(autoplayEnabled){
                let speed = parseInt(this.swiperContainer.dataset.speed) * 1000;
                swiperSettings.speed = Number.isFinite(speed) ? speed : 3000;
                swiperSettings.autoplay = {
                    delay: 0,
                    disableOnInteraction: false,
                    pauseOnMouseEnter: false,
                    waitForTransition: true           
                }
            }
    
            this.swiper = new Swiper(this.swiperContainer, swiperSettings);
            this.swiper.init();

            const wrapper = this.swiperContainer.querySelector('.swiper-wrapper');
            if(wrapper && autoplayEnabled){
                wrapper.style.transitionTimingFunction = 'linear';
            }

            this.setupInteractionPause(autoplayEnabled);
            this.getVisibleSlides();
            this.checkPagination();

            this.swiper.on('slideChange', () => {
                this.getVisibleSlides();
            });
    
            this.swiper.on('resize' ,() => {
                this.checkPagination();
            });
        }

        setupInteractionPause(autoplayEnabled){
            clearTimeout(this.autoplayResumeTimer);
            clearTimeout(this.manualPauseTimer);

            if(this.handleMouseEnter) this.removeEventListener('mouseenter', this.handleMouseEnter);
            if(this.handleMouseLeave) this.removeEventListener('mouseleave', this.handleMouseLeave);
            if(this.handleFocusIn) this.removeEventListener('focusin', this.handleFocusIn);
            if(this.handleFocusOut) this.removeEventListener('focusout', this.handleFocusOut);
            if(this.handleNavigationClick) this.removeEventListener('click', this.handleNavigationClick, true);

            if(!autoplayEnabled || !this.swiper.autoplay) return;

            const configuredSpeed = parseInt(this.swiperContainer.dataset.speed);
            this.continuousSpeed = Number.isFinite(configuredSpeed) ? configuredSpeed * 1000 : 3000;
            this.isPointerInside = false;
            this.isKeyboardFocusWithin = false;

            this.freezeMotion = () => {
                clearTimeout(this.autoplayResumeTimer);
                this.swiper.autoplay.stop();

                const wrapper = this.swiper.wrapperEl;
                const transform = window.getComputedStyle(wrapper).transform;
                let translateX = Number.isFinite(this.swiper.translate) ? this.swiper.translate : 0;

                if(transform && transform !== 'none'){
                    const matrix = transform.match(/matrix(3d)?\((.+)\)/);
                    if(matrix){
                        const values = matrix[2].split(',').map(Number);
                        translateX = matrix[1] === '3d' ? values[12] : values[4];
                    }
                }

                this.swiper.setTransition(0);
                this.swiper.setTranslate(translateX);
                this.swiper.animating = false;
                this.swiper.updateProgress(translateX);
                this.swiper.updateActiveIndex();
                this.swiper.updateSlidesClasses();
            };

            this.scheduleAutoplayResume = () => {
                clearTimeout(this.autoplayResumeTimer);
                this.autoplayResumeTimer = setTimeout(() => {
                    if(this.isPointerInside || this.isKeyboardFocusWithin) return;
                    this.swiper.params.speed = this.continuousSpeed;
                    this.swiper.autoplay.start();
                }, 600);
            };

            this.handleMouseEnter = () => {
                this.isPointerInside = true;
                this.freezeMotion();
            };

            this.handleMouseLeave = () => {
                this.freezeMotion();
                this.isPointerInside = false;
                this.scheduleAutoplayResume();
            };

            this.handleFocusIn = (event) => {
                if(event.target.matches && event.target.matches(':focus-visible')){
                    this.isKeyboardFocusWithin = true;
                    this.freezeMotion();
                }
            };

            this.handleFocusOut = (event) => {
                if(!this.contains(event.relatedTarget)){
                    this.isKeyboardFocusWithin = false;
                    this.scheduleAutoplayResume();
                }
            };

            this.handleNavigationClick = (event) => {
                const nextButton = event.target.closest('.swiper-button-next');
                const prevButton = event.target.closest('.swiper-button-prev');
                if(!nextButton && !prevButton) return;

                event.preventDefault();
                event.stopImmediatePropagation();
                this.freezeMotion();

                const slideGrid = this.swiper.slidesGrid || [];
                const gridStep = slideGrid.length > 1 ? Math.abs(slideGrid[1] - slideGrid[0]) : 0;
                const fallbackSize = this.swiper.slidesSizesGrid && this.swiper.slidesSizesGrid.length
                    ? this.swiper.slidesSizesGrid[0]
                    : this.swiper.width / this.swiper.params.slidesPerView;
                const spaceBetween = parseFloat(this.swiper.params.spaceBetween) || 0;
                const moveBy = gridStep || fallbackSize + spaceBetween;
                const targetTranslate = this.swiper.translate + (nextButton ? -moveBy : moveBy);

                this.swiper.setTransition(450);
                this.swiper.setTranslate(targetTranslate);
                this.swiper.animating = true;

                clearTimeout(this.manualPauseTimer);
                this.manualPauseTimer = setTimeout(() => {
                    this.swiper.autoplay.stop();
                    this.swiper.animating = false;
                    this.swiper.setTransition(0);
                    this.swiper.setTranslate(targetTranslate);
                    this.swiper.updateProgress(targetTranslate);
                    this.swiper.updateActiveIndex();
                    this.swiper.updateSlidesClasses();
            this.handleMouseLeave = () => {
                this.freezeMotion();
                this.isPointerInside = false;
                this.scheduleAutoplayResume();
            };
                }, 470);

                this.scheduleAutoplayResume();
            };

            this.addEventListener('mouseenter', this.handleMouseEnter);
            this.addEventListener('mouseleave', this.handleMouseLeave);
            this.addEventListener('focusin', this.handleFocusIn);
            this.addEventListener('focusout', this.handleFocusOut);
            this.addEventListener('click', this.handleNavigationClick, true);
        }

        getVisibleSlides(){
            if(this.swiper){
                const allSlides = this.swiper.slides;
                const activeIndex = this.swiper.activeIndex;
                const slidesPerView = this.swiper.params.slidesPerView;

                const visibleSlides = [];
                
                if(slidesPerView === 'auto'){
                    allSlides.forEach((slide) => {
                        const rect = slide.getBoundingClientRect();
                        if (rect.left >= 0 && rect.right <= window.innerWidth) {
                            visibleSlides.push(slide);
                        }
                    });
                }else{
                    for (let i = activeIndex; i < activeIndex + slidesPerView && i < allSlides.length; i++) {
                        visibleSlides.push(allSlides[i]);
                    }
                }
    
                allSlides.forEach((slide) => {
                    slide.querySelectorAll('.tab-able-item').forEach((item) => {
                        item.setAttribute('tabindex', '-1');
                    });
                });
    
                visibleSlides.forEach((slide) => {
                    slide.querySelectorAll('.tab-able-item').forEach((item) => {
                        item.setAttribute('tabindex', '0');
                    });
                });
            }
        }

        checkPagination(){
            var pagination = this.querySelector('.swiper-pagination');
            var btns = {
                prev: this.querySelector('.swiper-button-prev'),
                next: this.querySelector('.swiper-button-next')
            }
            if(pagination && pagination.querySelectorAll('.swiper-pagination-bullet').length <= 1){
                pagination.classList.add('d-none');
                if(btns.prev) btns.prev.style.display = 'none';
                if(btns.next) btns.next.style.display = 'none';
            }else{
                if(pagination) pagination.classList.remove('d-none');
                if(btns.prev) btns.prev.style.display = 'block';
                if(btns.next) btns.next.style.display = 'block';
            }
        }

        refresh(){
            if(this.swiper) this.swiper.destroy(true, true);
            this.initSwiper();
        }
    }
    
    customElements.define('custom-logo-list', CustomLogoList);
}